import { businessConfig } from "config/businessConfig";
import React, { createContext, useContext } from "react";

export const BusinessConfigContext = createContext();

const BusinessConfigProvider = ({ tenantEnvironment, children }) => {
    const config = businessConfig[tenantEnvironment] || {};

    return (
        <BusinessConfigContext.Provider value={config}>
            {children}
        </BusinessConfigContext.Provider>
    );
};

export default BusinessConfigProvider


